import usFlag from "../assets/images/flags/us.jpg";
import mx from "../assets/images/flags/mx.webp";

const languages = {
  sp: {
    label: "Spanish",
    flag: mx,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
};

export default languages;
